const React = require('react');
const BaseMessages = require('./BaseMessages');
const {withRouter} = require("react-router-dom");

class EmailMessagesPage extends React.Component {
    render() {
        return (
            <BaseMessages messagesType={'email'}/>
        )
    }
}

module.exports = withRouter(EmailMessagesPage);
